'use strict';

import * as dom from '../lib/dom.js';

function specialImage() {
    const specialPlaylists = document.querySelectorAll('.c-tab-specials__card-content');

    dom.forEachEl(specialPlaylists, (specialPlaylist) => {
        const specialItems = specialPlaylist.querySelectorAll('.js-special-episode');
        const specialThumbs = specialPlaylist.querySelectorAll('.js-special-thumb');
        
        dom.forEachEl(specialItems, (specialItem) => {
            specialItem.addEventListener('mouseover', function() {
                dom.forEachEl(specialThumbs, (specialThumb) => {
                    dom.removeClass(specialThumb, 'c-special-card-image--active');
                    if(specialItem.getAttribute('data-episode') === specialThumb.getAttribute('data-episode')) {
                        dom.addClass(specialThumb, 'c-special-card-image--active');
                    }
                });
            });
        });
    });

}

export default function(){
    window.addEventListener('load', function() {
        specialImage();
    })
}
